<template>
  <div>
    <section
      v-for="(contentElement, i) in content.nestedContent"
      :key="contentElement.key"
      :class="[getSpacingVertical(contentElement),
               getElementTemplate(contentElement) ? getSpacingTopClass(contentElement) + ' ' + getSpacingBottomClass(contentElement) : null ]"
    >
      <component
        :is="getElementTemplate(contentElement)"
        :content="contentElement"
        :is-first="i === 0"
      />
    </section>
  </div>
</template>

<script>
import elementResolverMixin from '@/mixins/elementResolverMixin';
import {
  getSpacingTopClass,
  getSpacingBottomClass
} from '@/utils/spacing-classes.js';

export default {
  name: 'Frontpage',
  mixins: [elementResolverMixin],
  methods: {
    getSpacingTopClass: getSpacingTopClass,
    getSpacingBottomClass: getSpacingBottomClass
  }
};
</script>
